import {
  DefaultButton,
  Panel,
  PanelType,
  PrimaryButton,
  TextField,
} from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import { useUpdateInvitationGroup } from './updateInvitationGroupPanel/utility/useUpdateInvitationGroup';
import { useInvitationGroupValidator } from '../utility/useInvitationGroupValidator';

const UpdateInvitationGroupPanel = ({
  invitationGroups,
  selectedInvitationGroupKey,
}) => {
  const { t: translator } = useTranslation();

  const {
    title,
    setTitle,
    isPanelOpen,
    onPanelClose,
    onConfirm,
  } = useUpdateInvitationGroup(invitationGroups, selectedInvitationGroupKey);

  const {
    validationFailed,
    renderValidationErrors,
  } = useInvitationGroupValidator(title, invitationGroups);

  return (
    <div>
      <Panel
        isOpen={isPanelOpen}
        type={PanelType.medium}
        onDismiss={onPanelClose}
        isLightDismiss={true}
        onOuterClick={() => {}}
        closeButtonAriaLabel={translator('ariaLabel.panelClose')}
      >
        <div>
          <div className="panel-content">
            <h3 className="panel-header">
              {translator(
                'pages.adminInvitationGroups.updateInvitationGroupPanel.header',
              )}
            </h3>
            <TextField
              label={translator(
                'pages.adminInvitationGroups.updateInvitationGroupPanel.guideText',
              )}
              value={title}
              onChange={(_, value) => setTitle(value)}
              placeholder={translator(
                'pages.adminInvitationGroups.updateInvitationGroupPanel.placeHolder',
              )}
            />
            {renderValidationErrors()}
          </div>
          <div className="panel-buttons">
            <DefaultButton
              text={translator('global.cancel')}
              onClick={onPanelClose}
            />
            <PrimaryButton
              text={translator('global.confirm')}
              onClick={onConfirm}
              disabled={validationFailed}
            />
          </div>
        </div>
      </Panel>
    </div>
  );
};

export { UpdateInvitationGroupPanel };
